import { render } from "./SplashTextColumn.vue.js?vue&type=template&id=608ae634&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashTextColumn.vue?vue&type=template&id=608ae634&scoped=true"
import script from "./SplashTextColumn.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashTextColumn.vue?vue&type=script&lang=js"
export * from "./SplashTextColumn.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashTextColumn.vue?vue&type=script&lang=js"

import "./SplashTextColumn.vue.scss?vue&type=style&index=0&id=608ae634&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashTextColumn.vue?vue&type=style&index=0&id=608ae634&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608ae634"],['__file',"src/Web/scripts/components/splash/SplashTextColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "608ae634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('608ae634', __exports__)) {
    api.reload('608ae634', __exports__)
  }
  
  module.hot.accept("./SplashTextColumn.vue.js?vue&type=template&id=608ae634&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashTextColumn.vue?vue&type=template&id=608ae634&scoped=true", () => {
    api.rerender('608ae634', render)
  })

}


export default __exports__